import React from "react";
import "../../App.css";
import Dashboard from "../Dashboard";

function DashboardPage({ sessionObject }) {
  if (!sessionObject.sessionVariables["modules"].includes("Dashboard")) {
    return;
  }
  return (
    <div className="page-mr">
      <Dashboard sessionObject={sessionObject} />
    </div>
  );
}

export default DashboardPage;
